export default "__VITE_ASSET__DkPZW1yz__"